import { Router } from '@angular/router';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MyListingsService } from '../../services/my-listings.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { HeaderComponent } from '../header/header.component';
import { ToastService, ToastType } from '../../services/toast.service';

interface Parking {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-parking',
  templateUrl: './parking.component.html',
  styleUrls: ['./parking.component.css']
})

export class ParkingComponent {
  @ViewChild(HeaderComponent) header: HeaderComponent;

  GarageSpaces: number;
  CarportSpaces: number;
  Driveway: string;
  parkingDetails: {};
  parkingFlag = false;

  @ViewChild('parkingInput') parkingInput: ElementRef<HTMLInputElement>;
  constructor(
    private router: Router,
    public localStorageService: LocalStorageService,
    public myListingsService: MyListingsService,
    public toastService: ToastService,
  ) {
    this.filteredParking = this.parkingCtrl.valueChanges.pipe(
      startWith(null),
      map((parking: string | null) =>
        parking ? this._filter(parking) : this.allParkings.slice()
      )
    );
  };

  separatorKeysCodes: number[] = [ENTER, COMMA];
  parkingCtrl = new FormControl('');
  filteredParking: Observable<string[]>;
  ParkingFeatures: any[] = [];
  // allParkings: string[] = ['Asphalt', 'Basement', 'Concrete', 'Deck', 'Gated', 'None', 'Open', 'Outside', 'Paved', 'Private', 'Storage', 'Underground', 'Varies by Unit'];
  allParkings: string[] = ['Additional Parking', 'Aggregate', 'Alley Access', 'Asphalt', 'Assigned', 'Attached', 'Attached Carport', 'Basement', 'Boat', 'Carport', 'Circular Driveway', 'Common', 'Community Structure', 'Concrete', 'Converted Garage', 'Covered', 'Deck', 'Deeded', 'Detached', 'Detached Carport', 'Direct Access', 'Drive Through', 'Driveway', 'Electric Gate', 'Electric Vehicle Charging Station(s)', 'Enclosed', 'Garage', 'Garage Door Opener', 'Garage Faces Front', 'Garage Faces Rear', 'Garage Faces Side', 'Gated', 'Golf Cart Garage', 'Gravel', 'Guest', 'Heated Garage', 'Inside Entrance', 'Kitchen Level', 'Leased', 'Lighted', 'No Garage', 'None', 'Off Site', 'Off Street', 'On Site', 'On Street', 'Open', 'Other', 'Outside', 'Oversized', 'Parking Lot', 'Parking Pad', 'Paved', 'Paver Block', 'Permit Required', 'Private', 'RV Access/Parking', 'RV Carport', 'RV Garage', 'RV Gated', 'Secured', 'Shared Driveway', 'Side By Side', 'Storage', 'Tandem', 'Unassigned', 'Underground', 'Unpaved', 'Valet', 'Varies by Unit', 'Workshop in Garage'];
  parking: Parking[] = [
    { value: 'Asphalt', viewValue: 'Asphalt' },
    { value: 'Basement', viewValue: 'Basement' },
    { value: 'Concrete', viewValue: 'Concrete' },
    { value: 'Deck', viewValue: 'Deck' },
    { value: 'Gated', viewValue: 'Gated' },
    { value: 'None', viewValue: 'None' },
    { value: 'Open', viewValue: 'Open' },
    { value: 'Outside', viewValue: 'Outside' },
    { value: 'Paved', viewValue: 'Paved' },
    { value: 'Private', viewValue: 'Private' },
    { value: 'Storage', viewValue: 'Storage' },
    { value: 'Underground', viewValue: 'Underground' },
    { value: 'Varies by Unit', viewValue: 'Varies by Unit' },
  ];

  historyState: any;
  myListingId: string;
  isLoader = false;

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.ParkingFeatures.push(value);
    }
    event.chipInput!.clear();
    this.parkingCtrl.setValue(null);
  }

  remove(parking: string): void {
    const index = this.ParkingFeatures.indexOf(parking);
    if (index >= 0) {
      this.ParkingFeatures.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.ParkingFeatures.push(event.option.viewValue);
    this.ParkingFeatures = this.removeDuplicates(this.ParkingFeatures);
    this.parkingInput.nativeElement.value = '';
    this.parkingCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allParkings.filter((parking) =>
      parking.toLowerCase().includes(filterValue)
    );
  }

  removeDuplicates(arr): any[] {
    return [...new Set(arr)];
  }

  ngOnInit(): void {
    this.historyState = history.state;
    if (!this.historyState.address) {
      this.router.navigateByUrl('/my-listing');
      return;
    }
    this.myListingId = this.historyState.myListingId ? this.historyState.myListingId : this.localStorageService.get('myListingId') ? this.localStorageService.get('myListingId') : null;
    if (this.historyState && this.historyState.parkingDetails) {
      this.ParkingFeatures = this.historyState.parkingDetails.ParkingFeatures;
      this.GarageSpaces = this.historyState.parkingDetails.GarageSpaces;
      this.CarportSpaces = this.historyState.parkingDetails.CarportSpaces;
      this.Driveway = this.historyState.parkingDetails.Driveway;
    } else {

      if (this.historyState.listingDetails && this.historyState.listingDetails.ParkingFeatures) {
        this.ParkingFeatures = this.historyState.listingDetails.ParkingFeatures.split(',');
      } else {
        this.ParkingFeatures = [];
      }
      this.CarportSpaces = this.historyState.listingDetails && this.historyState.listingDetails.CarportSpaces ? typeof (this.historyState.listingDetails.CarportSpaces) == 'string' ? parseInt(this.historyState.listingDetails.CarportSpaces) : this.historyState.listingDetails.CarportSpaces : null;
      this.Driveway = this.historyState.listingDetails && this.historyState.listingDetails.Driveway ? this.historyState.listingDetails.Driveway : null;

      if (this.historyState.listingDetails && this.historyState.listingDetails.GarageSpaces) {
        if (typeof (this.historyState.listingDetails.GarageSpaces) == 'string') {
          this.GarageSpaces = parseInt(this.historyState.listingDetails.GarageSpaces);
        } else {
          this.GarageSpaces = this.historyState.listingDetails.GarageSpaces;
        }

      } else if (this.historyState.propertyDetails && (this.historyState.propertyDetails.GarageSpaces !== 0 || this.historyState.propertyDetails.GarageSpaces == 0)) {

        if (typeof (this.historyState.propertyDetails.GarageSpaces) == 'string') {
          this.GarageSpaces = parseInt(this.historyState.propertyDetails.GarageSpaces);
        } else {
          this.GarageSpaces = this.historyState.propertyDetails.GarageSpaces;
        }
      } else {
        this.GarageSpaces = null;
      }
    }
  }


  back() {
    this.router.navigateByUrl('/home-details', {
      state: this.historyState
    });
  }

  saveParkingDetails(submit) {

    if (this.ParkingFeatures.length > 0) { //|| (submit == 'skip')
      this.parkingFlag = false;
      this.isLoader = true;
      this.parkingDetails = {
        ParkingFeatures: this.ParkingFeatures,
        GarageSpaces: this.GarageSpaces,
        CarportSpaces: this.CarportSpaces,
        Driveway: this.Driveway
      }
      this.updateMyListings(submit);
    } else {
      this.parkingFlag = true;
      this.toastService.toast('Madatory fields are not filled', ToastType.Warning);
    }

  }

  updateMyListings(submit) {
    if (submit == null || submit == 'skip') {
      if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.2) {
        this.parkingDetails["stage"] = 1.2;
      }

      if (this.historyState.stageName) {
        if (this.historyState.stageName.split(',').indexOf('Parking') <= -1) {
          this.parkingDetails["stageName"] = "Parking" + "," + this.historyState.stageName;
        }
      } else {
        this.parkingDetails["stageName"] = "Parking" + "," + "Home Details";
      }
    }

    this.parkingDetails["updatedDate"] = new Date();

    this.parkingDetails = this.filterInputJson(this.parkingDetails);

    this.myListingsService.UpdateListing(this.myListingId, this.parkingDetails).subscribe(
      {
        next: (res) => {

          if (!this.historyState.completedIndex || this.historyState['completedIndex'] < 1.2) {
            this.historyState['completedIndex'] = 1.2;
          }
          this.historyState['parkingDetails'] = this.parkingDetails;
          this.historyState.stageName = this.parkingDetails["stageName"];

          this.isLoader = false;
           if (submit == 'skip') {
            this.historyState['completedIndex'] = 1.7;
            this.router.navigateByUrl('/plans', {
              state: this.historyState
            });
          } else {
            this.router.navigateByUrl('/basement', {
              state: this.historyState
            });
          }
        },
        error: (err) => {
          console.log('UpdateListing err!!!!');
          this.isLoader = false;
          console.log(err);
        }
      }
    );
  }

  skip() {
    this.historyState['completedIndex'] = 1.7;
    this.router.navigateByUrl('/plans', {
      state: this.historyState
    });
  }

  filterInputJson(obj) {
    Object.keys(obj).forEach(key => {
      if (obj[key] == null) {
        delete obj[key];
      }
    });
    return obj;
  }

}
